import {Alert, AppBar, IconButton, Tooltip} from '@mui/material'
import React, { useState, useEffect } from 'react'
import {Grid, Container, Stack, Button} from '@mui/material'
import PupilSurveyCard from './PupilSurveyCard'
import WbButton from '../../components/common/WbButton'
import {useNavigate} from 'react-router-dom'
import paths from '../../routes/paths'
import unifiedLogout from '../../utils/unifiedLogout'
import CheckIn from '../CheckIn'
import usePupilData from '../../hooks/usePupilData'
import { safeSpaceApi } from '../../services/api/safespace/safeSpaceApi'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export default function PupilDashboard({surveys}) {
  const navigate = useNavigate()
  const pupil = usePupilData();
  const [schoolSettings, setschoolSettings] = useState([]);
  const [safeSpaceConfig, setSafeSpaceConfig] = useState({
      allowInPersonResponse: false,
      allowMessageResponse: false,
      isZoneOfRegulationEnabled: false,
      isSafeSpaceEnabled: false,
      isSimpleExperienceForAllStudents: false,
      messages: []
    });

  useEffect(() => {
      const fetchStaffSettings = async () => {
        try {                   
          const studentId = pupil?.studentId;       
          const schoolId = pupil?.schoolId;       
          const groupId = pupil?.groupId;     
          const isMAT = (pupil?.groupId==null || pupil?.groupId==="" || pupil?.groupId===0) ? false : true;  
          safeSpaceApi.getSafeSpaceSettings(schoolId,groupId,isMAT)
              .then((settings) => {       
              //debugger;   
                if (settings !=null) {                
                  setschoolSettings(settings);
                  console.log("schoolSettings",settings);
                  // Store specific settings in state
                  setSafeSpaceConfig({
                    allowInPersonResponse: settings.allowInPersonResponse,
                    allowMessageResponse: settings.allowMessageResponse,
                    isZoneOfRegulationEnabled: settings.isZoneOfRegulationEnabled,
                    isSafeSpaceEnabled: settings.isSafeSpaceEnabled,
                    isSimpleExperienceForAllStudents: settings.isSimpleExperienceForAllStudents,
                    messages: settings.messages.map(msg => ({
                      isEnabled: msg.isEnabled,
                      messageContent: msg.messageContent,
                      messageType: msg.messageType,
                      outOfHoursStartTime: msg.outOfHoursStartTime,
                      outOfHoursEndTime: msg.outOfHoursEndTime,
                      schools: msg.schools
                    }))
                  });  
                  // Store in localStorage for access in other components
                  localStorage.setItem('safeSpaceConfig', JSON.stringify(settings));                                   
                }
              })
              .catch((error) => { }); 
  
          // Fetch safe space school settings               
          // safeSpaceApi.GetSafeSpaceSettings(schoolId,groupId,isMAT)
          // .then((response) => {          
          //    if (response !=null) {
          //     debugger;
          //     setschoolSettings(response);
          //     setLoading(false);
          //   }
          // })
          // .catch((error) => { });
         
        } catch (err) {
          
        }
      };
  
      fetchStaffSettings();
    }, []);

    
  const renderPupilName = () => {
    let time =
      new Date().getHours() < 12
        ? 'morning'
        : new Date().getHours() < 17
          ? 'afternoon'
          : 'evening'

    if (pupil) {
      return (
        <div>
          <b>
            Good {time} {pupil.studentFirstName}
          </b>
        </div>
      )
    }
  }

  return (
    <>
      <AppBar className="header">
        <Container maxWidth="xxl">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <div className="logo">
              <span>Welbee</span>
            </div>
            <div>
              <nav>
                <Stack direction="row" spacing={1} alignItems="center">
                  {renderPupilName()}
                  <Tooltip title="Logout" placement="bottom" arrow>
                    <WbButton
                      onClick={() => {
                        unifiedLogout();
                      }}                      
                      CustomButtonText="Logout"
                    />
                  </Tooltip>
                </Stack>
              </nav>
            </div>
          </Stack>
        </Container>
      </AppBar>
   
      <div className="main-container">
        <Container maxWidth="lg">
          <Grid container spacing={2} mt={1}>
            <CheckIn />
            {safeSpaceConfig.isSafeSpaceEnabled && (
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <div
                className="my-safespace"
                onClick={e => navigate(paths.conversations)}
              >
                <h1>
                  <b>My Safe Space</b>
                </h1>
                <p>Send a Message to a trusted adult</p>
                <div className="safespace-bottom">
                  You can use safe space to send a message to a trusted adult in school. 
                  You can talk about anything, including things that may be worrying you or 
                  something you want an adult to know.
                </div>
              </div>
            </Grid>
            )}
          </Grid>
           
          <Grid container spacing={2} mt={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <h1>All Surveys</h1>
            </Grid>
            {surveys?.length === 0 && (
              <Grid item lg={12} md={12} sm={12} xs={12}>                
                <Alert severity="error" icon={<InfoOutlinedIcon fontSize="inherit" />}>
                  No Surveys Found. Please check back later or contact your
                  school for more information.
                </Alert>
              </Grid>
            )}

            {surveys.map((survey, index) => (
              <Grid item lg={4} md={4} sm={6} xs={12} key={index}>
                <PupilSurveyCard survey={survey} index={index} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>
    </>
  )
}
